const envConfigs = {
	dev: {
		googleTag: {
			gTagId: 'G-4VW2LRNCMH',
			enabled: true,
		},
		applicationInsightConnectionString:
			'InstrumentationKey=0bfebb51-4d48-4199-a3d0-4d05d008b694;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/',
	},
	tst: {
		googleTag: {
			gTagId: 'G-V5TCZFWVY3',
			enabled: true,
		},
		applicationInsightConnectionString:
			'InstrumentationKey=ca3cae62-951b-4120-b2b7-b33cfc0fa973;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/',
	},
	stg: {
		googleTag: {
			gTagId: '',
			enabled: false,
		},
		applicationInsightConnectionString:
			'InstrumentationKey=219235ec-f639-405b-98dd-89b884a08f9b;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/',
	},
	prod: {
		googleTag: {
			gTagId: 'G-91T5FJ4FBH',
			enabled: true,
		},
		applicationInsightConnectionString:
			'InstrumentationKey=5f85e65c-5761-4391-afeb-d38a982b2c96;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/',
	},
};

// function used to get different config ids based on the env passed in
// see helper util getEnvironment for how to get the env we are currently in
const getEnvConfig = (env, configName) => {
	if (!envConfigs[env]) {
		if (process.env.NODE_ENV === 'development') {
			// eslint-disable-next-line
			console.warn('config doesnt exist');
		}
		return null;
	}
	return envConfigs[env][configName];
};

export default getEnvConfig;